import { render, staticRenderFns } from "./ProfileEditTabAttributes.vue?vue&type=template&id=36825ba6&"
import script from "./ProfileEditTabAttributes.vue?vue&type=script&lang=js&"
export * from "./ProfileEditTabAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditTabAttributes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports